//
// # DeleteDesignDialog
//
// Confirmation modal shown when the user right-clicks a design in the
// explorer tree and chooses "Delete". Displays the design path and
// requires explicit confirmation before deleting from the depot.
//

import React, { useCallback } from "react";

import { Ident } from "GenAlphaModel";

import { Modal } from "./Modal/Modal";
import { useWorkspace } from "../context";

export interface DeleteDesignDialogProps {
  readonly ident: Ident | null;
  readonly onClose: () => void;
}

export function DeleteDesignDialog({
  ident,
  onClose,
}: DeleteDesignDialogProps) {
  const workspace = useWorkspace();

  const displayName = ident ? Ident.displayName(ident) : "";

  const handleDelete = useCallback(async () => {
    if (!ident) return;
    onClose();
    await workspace.deleteDesign(ident);
  }, [workspace, ident, onClose]);

  return (
    <Modal open={ident !== null} onClose={onClose} title="Delete Design">
      <div className="flex flex-col gap-4">
        <p className="text-sm" style={{ color: "var(--color-ide-text-muted)" }}>
          Are you sure you want to delete{" "}
          <span
            className="font-mono font-semibold"
            style={{ color: "var(--color-ide-text)" }}
          >
            {displayName}
          </span>
          ? This action cannot be undone.
        </p>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs rounded border"
            style={{
              borderColor: "var(--color-ide-border)",
              color: "var(--color-ide-text-muted)",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => void handleDelete()}
            className="px-3 py-1.5 text-xs rounded font-semibold"
            style={{
              backgroundColor: "var(--color-ide-error, #e53e3e)",
              color: "white",
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
}
